// Sentry init for the web. DSN comes from VITE_SENTRY_DSN at build
// time; empty / missing = no-op (Sentry doesn't dispatch).

import * as Sentry from "@sentry/react";

const DSN = (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? "";
const ENVIRONMENT =
  (import.meta.env.VITE_DEPLOY_ENV as string | undefined) ??
  (import.meta.env.MODE as string | undefined) ??
  "development";

export function initSentry() {
  if (!DSN) return;
  Sentry.init({
    dsn: DSN,
    environment: ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: ENVIRONMENT === "production" ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
}
